<ng-container data-cy="progress-bar" [ngSwitch]="barType">
  <app-progress-bar-bullets
    *ngSwitchCase="progressBarType.bullets"
    [currentIndex$]="currentIndex$"
    [stepOrder]="stepOrder"
  ></app-progress-bar-bullets>
  <app-progress-bar-images
    *ngSwitchCase="progressBarType.images"
    [currentIndex$]="currentIndex$"
    [stepOrder]="stepOrder"
    [isCompleted]="isCompleted"
  ></app-progress-bar-images>
  <app-progress-bar-text
    *ngSwitchCase="progressBarType.text"
    [currentIndex$]="currentIndex$"
    [stepOrder]="stepOrder"
  ></app-progress-bar-text>
  <app-progress-bar-line
    *ngSwitchCase="progressBarType.line"
    [currentIndex$]="currentIndex$"
    [stepOrder]="stepOrder"
    [isCompleted$]="isCompleted$"
  ></app-progress-bar-line>
</ng-container>
